import { error, ValidationError } from 'common/errors';
import { pushINOData, pushUctpInitiateIdentityValidation } from 'common/gamp';
import { markEnd, markStart } from 'common/instrumentation';
import { VISA } from 'common/network-partners';
import { CommunicatorState, getState, saveApiResponseCache } from 'orch-communicator/store';
import { InitiateIdentityValidationPayload } from 'types/vsb-sdk/initiate-identity-validation';

export default async function initiateIdentityValidation(): Promise<
  InitiateIdentityValidationPayload | ValidationError
> {
  //eslint-disable-next-line
  const vSDK = getState().srcSdks.loadedSdk as { [key: string]: any };
  const otpProvider = getState().meta.otpProvider || VISA;

  /* eslint-disable @typescript-eslint/no-explicit-any */
  try {
    /* START GENAI@GHCOPILOT */
    markStart(`vsb_initiate_identity_validation_${otpProvider}`);
    const reissuanceResponse = await vSDK[otpProvider].initiateIdentityValidation({});
    const communicatorState = getState() as CommunicatorState;

    const apiResponseCache = {
      ...communicatorState.srcSdks.apiResponseCache,
      cardBrand: getState().meta.otpProvider,
      initiateIdentityValidation: reissuanceResponse
    };

    saveApiResponseCache(apiResponseCache);

    markEnd(`vsb_initiate_identity_validation_${otpProvider}`);
    /* END GENAI@GHCOPILOT */
    // START GENAI@GHCOPILOT
    pushUctpInitiateIdentityValidation(otpProvider, undefined);
    // END GENAI@GHCOPILOT
    pushINOData(null, 'VSB getCards IDV', 'vsb_initiate_identity_validation_');
    return reissuanceResponse;
  } catch (e: any) {
    //START GENAI@GHCOPILOT
    if (otpProvider === 'VISA') {
      //eslint-disable-next-line
      e = e.error;
    }

    if (e && 'reason' in e && e.reason === 'ACCT_INACCESSIBLE') {
      // START GENAI@GHCOPILOT
      pushUctpInitiateIdentityValidation(otpProvider, e.reason);
      // END GENAI@GHCOPILOT
      throw error(
        'ACCT_INACCESSIBLE',
        'The user account exists but is not currently accessible.',
        ' ' as any
      );
    } else if (e && 'reason' in e && e.reason === 'RETRIES_EXCEEDED') {
      // START GENAI@GHCOPILOT
      pushUctpInitiateIdentityValidation(otpProvider, e.reason);
      // END GENAI@GHCOPILOT
      throw error('RETRIES_EXCEEDED', 'The limit for the number of retries exceeded.', ' ' as any);
    }

    // START GENAI@GHCOPILOT
    pushUctpInitiateIdentityValidation(otpProvider, 'The OTP could not be sent to the recipient.');
    // END GENAI@GHCOPILOT
    throw error('OTP_SEND_FAILED', 'The OTP could not be sent to the recipient.', ' ' as any);
    //END GENAI@GHCOPILOT
  }
}
